import { render } from "./PartData.vue?vue&type=template&id=35f0468e&scoped=true"
import script from "./PartData.vue?vue&type=script&lang=js"
export * from "./PartData.vue?vue&type=script&lang=js"

import "./PartData.vue?vue&type=style&index=0&id=35f0468e&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f0468e"]])

export default __exports__